(() => {
  function setup(root) {
    if (root.dataset.pcbReady === 'true') return;
    const config = root.querySelector('[data-pcb-finder-copy]');
    const device = root.querySelector('[data-pcb-device]');
    const brand = root.querySelector('[data-pcb-brand]');
    const model = root.querySelector('[data-pcb-model]');
    const submit = root.querySelector('[data-pcb-submit]');
    const tools = root.querySelector('[data-pcb-model-tools]');
    const search = root.querySelector('[data-pcb-model-search]');
    const count = root.querySelector('[data-pcb-model-count]');
    const status = root.querySelector('[data-pcb-load-status]');
    const retry = root.querySelector('[data-pcb-retry]');
    const browse = root.querySelector('[data-pcb-browse-brand]');
    const hint = root.querySelector('[data-pcb-finder-hint]');
    if (!config || !device || !brand || !model || !submit || !search) return;
    const copy = JSON.parse(config.textContent);
    root.dataset.pcbReady = 'true';
    const brands = Array.from(root.querySelectorAll('[data-pcb-brand-data]'));
    const menuModels = Array.from(root.querySelectorAll('[data-pcb-model-data]'));
    const storageKey = 'phonecbdRepairSelectionV1';
    let modelList = [];
    let destination = '';
    let loadToken = 0;
    let interacted = false;
    let failedAction = null;

    const normalize = value => String(value || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/\+/g, 'plus').replace(/[^a-z0-9]/g, '');
    const matches = (label, query) => String(query || '').trim().split(/\s+/).map(normalize).filter(Boolean).every(term => normalize(label).includes(term));
    const route = value => {
      try {
        const url = new URL(value, location.origin);
        return value && url.origin === location.origin ? url.pathname : '';
      } catch (_) { return ''; }
    };
    const label = value => String(value || '').replace(/\s+/g, ' ').trim().replace(/\biphone\b/gi, 'iPhone').replace(/\b(iPhone\s+\d+)\s?e\b/gi, '$1e').replace(/\bipad\b/gi, 'iPad').replace(/\bimac\b/gi, 'iMac').replace(/\bmacbook\b/gi, 'MacBook').replace(/\blg\b/gi, 'LG').replace(/\bpro max\b/gi, 'Pro Max').replace(/\bpro\b/gi, 'Pro').replace(/\bplus\b/gi, 'Plus').replace(/\bmini\b/gi, 'mini').replace(/\bair\b/gi, 'Air');
    const reset = (select, placeholder) => select.replaceChildren(new Option(placeholder, ''));
    const add = (select, value, title, url, collection = '') => {
      const option = new Option(label(title), value);
      option.dataset.url = route(url);
      option.dataset.collection = collection;
      select.add(option);
    };
    function notice(message = '', action = null) {
      status.textContent = message;
      status.hidden = !message;
      failedAction = action;
      retry.hidden = !action;
    }
    function sync() {
      submit.disabled = !destination;
      const selected = [device, brand, model].filter(field => !field.disabled && field.value).map(field => field.selectedOptions[0]?.textContent || '').filter(Boolean);
      const help = root.querySelector('[data-pcb-help-link]');
      if (help && window.PCBRepair) help.href = window.PCBRepair.whatsapp([window.PCBRepair.text('helpMessage'), ...selected].join(' — '));
    }
    function remember() {
      const selection = {device: device.value, brand: brand.value, modelUrl: model.value, modelLabel: model.selectedOptions[0]?.textContent || ''};
      try { sessionStorage.setItem(storageKey, JSON.stringify(selection)); } catch (_) {}
    }
    function clearModels() {
      modelList = [];
      search.value = '';
      tools.hidden = true;
      count.textContent = '';
      model.disabled = true;
      model.removeAttribute('aria-busy');
      reset(model, copy.choose_brand_first);
    }
    function updateModels(preserved = model.value) {
      const filtered = modelList.filter(item => matches(item.title, search.value));
      reset(model, filtered.length ? copy.choose_model : copy.no_results);
      filtered.forEach(item => add(model, item.url, item.title, item.url));
      model.disabled = filtered.length === 0;
      const keep = preserved && filtered.some(item => item.url === preserved);
      model.value = keep ? preserved : '';
      destination = keep ? preserved : '';
      count.textContent = filtered.length === 0 ? copy.no_results_help : filtered.length === 1 ? copy.count_one : copy.count_many.replace('__COUNT__', String(filtered.length));
      sync();
    }
    function pcRoute(option) {
      if (!option?.value) return '';
      const key = normalize(option.textContent + ' ' + option.value);
      if (key.includes('macbook') || key.includes('imac')) return '/pages/marseille-reparation-macbook';
      if (key.includes('informatique') || key.includes('ordinateur') || option.dataset.pcbPc === 'true') return '/pages/depannage-informatique-marseille';
      return '';
    }
    async function catalogue() {
      if (window.PCBRepair) return window.PCBRepair;
      await new Promise(resolve => {
        const ready = () => { clearTimeout(timer); document.removeEventListener('pcb:repair-ready', ready); resolve(); };
        const timer = setTimeout(ready, 1500);
        document.addEventListener('pcb:repair-ready', ready, {once: true});
      });
      if (!window.PCBRepair) throw new Error('Repair catalogue unavailable');
      return window.PCBRepair;
    }
    function deduplicate(items) {
      const seen = new Set();
      return items.flatMap(item => {
        const url = route(item.url);
        const title = label(item.title || item.label);
        if (!url || !title || seen.has(url)) return [];
        seen.add(url);
        return [{title, url}];
      });
    }
    async function selectDevice() {
      const token = ++loadToken;
      destination = '';
      notice();
      clearModels();
      brand.disabled = true;
      brand.removeAttribute('aria-busy');
      reset(brand, copy.choose_device_first);
      hint.textContent = copy.start_hint;
      const option = device.selectedOptions[0];
      browse.href = route(option?.dataset.url) || '/pages/remise-en-etat-telephone';
      browse.textContent = copy.all_brands;
      sync();
      if (!device.value) return;
      const direct = pcRoute(option);
      if (direct) {
        reset(brand, copy.not_required);
        reset(model, copy.not_required);
        destination = direct;
        browse.href = direct;
        browse.textContent = copy.browse_device;
        hint.textContent = copy.computer_hint;
        sync();
        return;
      }
      let matching = brands.filter(item => item.dataset.device === device.value).map(item => ({key: item.dataset.key, label: item.dataset.label, url: item.dataset.url, collection: item.dataset.collection}));
      if (!matching.length && /smartphone|telephone/.test(normalize(option.textContent))) {
        reset(brand, copy.loading);
        brand.setAttribute('aria-busy', 'true');
        notice(copy.brands_loading);
        try {
          const api = await catalogue();
          matching = (await api.loadBrands(option.dataset.url || '/pages/remise-en-etat-telephone')).map(item => ({...item, key: device.value + '--' + normalize(item.label)}));
        } catch (_) {
          if (token !== loadToken) return;
          brand.removeAttribute('aria-busy');
          reset(brand, copy.unavailable);
          notice(copy.brands_fallback, selectDevice);
          sync();
          return;
        }
      }
      if (token !== loadToken) return;
      brand.removeAttribute('aria-busy');
      notice();
      if (matching.length) {
        reset(brand, copy.choose_brand);
        matching.forEach(item => add(brand, item.key, item.label, item.url, item.collection));
        brand.disabled = false;
        hint.textContent = copy.brand_hint;
      } else {
        reset(brand, copy.not_required);
        reset(model, copy.not_required);
        destination = route(option.dataset.url);
        hint.textContent = copy.device_hint;
      }
      sync();
    }
    async function selectBrand() {
      const token = ++loadToken;
      destination = '';
      notice();
      clearModels();
      const option = brand.selectedOptions[0];
      browse.href = route(option?.dataset.url) || route(device.selectedOptions[0]?.dataset.url) || '/pages/remise-en-etat-telephone';
      browse.textContent = brand.value ? copy.browse_models : copy.all_brands;
      hint.textContent = brand.value ? copy.model_hint : copy.brand_hint;
      sync();
      if (!brand.value) return;
      let items = menuModels.filter(item => item.dataset.brand === brand.value).map(item => ({title: item.dataset.label, url: item.dataset.url}));
      if (option.dataset.collection) {
        reset(model, copy.loading);
        model.setAttribute('aria-busy', 'true');
        notice(copy.models_loading);
        try {
          const api = await catalogue();
          items = await api.loadModels('/collections/' + encodeURIComponent(option.dataset.collection));
        } catch (_) {
          if (token !== loadToken) return;
          model.removeAttribute('aria-busy');
          reset(model, copy.unavailable);
          notice(copy.models_error, selectBrand);
          sync();
          return;
        }
      }
      if (token !== loadToken) return;
      model.removeAttribute('aria-busy');
      notice();
      modelList = deduplicate(items);
      if (modelList.length) {
        tools.hidden = false;
        updateModels('');
      } else {
        reset(model, copy.browse_models);
        destination = route(option.dataset.url);
        hint.textContent = copy.device_hint;
        sync();
      }
    }
    Array.from(device.options).forEach(option => {
      const key = normalize(option.textContent);
      if (key.includes('smartphone')) option.textContent = copy.smartphone;
      else if (key.includes('tablette') || key.includes('ipad')) option.textContent = copy.tablet;
      else if (key.includes('console')) option.textContent = copy.console;
      else if (key.includes('macbook') || key.includes('imac')) option.textContent = copy.mac;
      else if (key.includes('informatique') || key.includes('ordinateur') || key === 'pc') {
        option.dataset.pcbPc = 'true';
        option.textContent = copy.pc_label;
        option.dataset.url = '/pages/depannage-informatique-marseille';
      }
    });
    let pcSeen = false;
    Array.from(device.options).forEach(option => {
      if (option.dataset.pcbPc !== 'true') return;
      if (pcSeen) option.remove();
      pcSeen = true;
    });
    device.addEventListener('change', () => { interacted = true; selectDevice(); remember(); });
    brand.addEventListener('change', () => { interacted = true; selectBrand(); remember(); });
    model.addEventListener('change', () => { interacted = true; destination = route(model.value); sync(); remember(); });
    search.addEventListener('input', () => { interacted = true; updateModels(); remember(); });
    search.addEventListener('keydown', event => {
      if (event.key !== 'Enter') return;
      event.preventDefault();
      if (model.disabled) return;
      if (model.options.length === 2) {
        model.selectedIndex = 1;
        model.dispatchEvent(new Event('change', {bubbles: true}));
        submit.focus();
      } else model.focus();
    });
    retry.addEventListener('click', () => { interacted = true; if (failedAction) failedAction(); });
    submit.addEventListener('click', () => { if (destination) location.assign(destination); });
    device.value = '';
    reset(brand, copy.choose_device_first);
    brand.disabled = true;
    clearModels();
    sync();
    async function restore() {
      let saved;
      try { saved = JSON.parse(sessionStorage.getItem(storageKey) || '{}'); } catch (_) { return; }
      if (!saved.device || interacted || device.value || !Array.from(device.options).some(option => option.value === saved.device)) return;
      device.value = saved.device;
      await selectDevice();
      if (interacted || device.value !== saved.device || !saved.brand || !Array.from(brand.options).some(option => option.value === saved.brand)) return;
      brand.value = saved.brand;
      await selectBrand();
      if (interacted || brand.value !== saved.brand || !saved.modelUrl || !modelList.some(item => item.url === saved.modelUrl)) return;
      model.value = saved.modelUrl;
      destination = route(saved.modelUrl);
      sync();
    }
    restore().catch(() => {});
  }
  const init = () => document.querySelectorAll('.pcb-repair-finder').forEach(root => {
    try { setup(root); } catch (_) {}
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();

